import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'

import { RestClientService } from './rest.service'
import { InEvent } from '@@n2-interfaces/in-event'
import { Observable } from 'rxjs'

@Injectable()
export class EventServiceService extends RestClientService {
    baseUrl = 'http://localhost:8080/'

    constructor(protected override http: HttpClient) {
        super(http)
    }

    getEvent(eventCode: string): Observable<any> {
        return this.get<any>(`event/${eventCode}`)
    }

    subscribeEmail(email: string): Observable<any> {
        return this.get<any>(`subscribe?email=${email}`)
    }

    respond(reply: string, event: InEvent): Observable<any> {
        return this.get<any>(
            'online/webJoinEvent/' + event.event.eventCode + '/' + reply,
            { withoutTenant: true }
        )
    }
}
